import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-and-monitoring',
  templateUrl: './risk-and-monitoring.component.html',
  styleUrls: ['./risk-and-monitoring.component.scss']
})
export class RiskAndMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
